document.addEventListener('DOMContentLoaded', function(){

    gsap.registerPlugin(ScrollTrigger);
    
    document.querySelectorAll('.faq-category__anchor').forEach(el => {
      const id = el.getAttribute('id');
      const title = el.getAttribute('data-title');
    
      const item = document.createElement('li');
      const link = document.createElement('a');
      const span = document.createElement('span');
    
      link.href = `#${id}`;
      span.innerText = title;
    
      link.appendChild(span);
      item.appendChild(link);
    
      document.querySelector('.faq-main__tab-links').appendChild(item);
    });
    
    $('.faq-category__toggle').on('click', function() {
      const $target = $(this).closest('.faq-main');
    
      $('.faq-main.active').not($target).removeClass('active');
      $target.toggleClass('active');
    });
    
    
    
    ScrollTrigger.matchMedia({
      "(min-width: 992px)": function() {
    
        const offset = $('.header').height() + 110;
        const offsetBottom = $('.faq-main__tab-links').height() + offset + 40;
    
        const ST = ScrollTrigger.create({
          trigger: '.faq-main__left--sticky',
          endTrigger: '.shopify-section-group-main-footer-group',
          start: `${ -offset } top`,
          end: `${ -offsetBottom } top`,
          pin: true,
          pinType: 'fixed',
          pinSpacing: false,
        })
    
      }
    })
    
    document.querySelectorAll('.faq-main__tab-links li a').forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
    
        const targetId = this.getAttribute('href');
        if (!targetId || targetId.charAt(0) !== '#') return;
    
        const targetEl = document.querySelector(targetId);
        if (!targetEl) return;
    
        const OFFSET = 140; // 👈 adjust this
        const y =
          targetEl.getBoundingClientRect().top +
          window.pageYOffset -
          OFFSET;
    
        window.scrollTo({
          top: y,
          behavior: 'smooth'
        });
      });
    });
    
    })
    